import styled from 'styled-components';

export const ThumbnailCover = styled.div`
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
`;
export const ImageStyle = styled.img`
  width: 68px;
  height: 68px;
  border-radius: 4px;
  cursor: pointer;
  background-color: rgb(246, 246, 246);
  ${(props) => (props.selected ? `border: 3px solid rgb(239, 78, 94)` : null)}
`;
export const ZoomImageContainer = styled.div`
  height: calc(100vh - 140px);
  width: -webkit-fill-available;
  display: flex;
`;

export const ImageContainer = styled.div`
  @media (min-width: 720px) {
    padding-bottom: 30px;
    padding-top: 30px;
  }
`;

export const RelativeDiv = styled.div`
  position: relative;
`;

export const ImageCover = styled.div`
  margin-left: 5px;
`;
